var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.125 4.375H0.875V20.65H11.375L10.7917 22.8083H9.39167V23.8H18.5792V22.8083H17.15L16.5375 20.65H27.0958V4.375H27.125ZM14 20.5042C13.5042 20.5042 13.0958 20.0958 13.0958 19.6C13.0958 19.1042 13.5042 18.6958 14 18.6958C14.4958 18.6958 14.9042 19.1042 14.9042 19.6C14.9042 20.0958 14.4958 20.5042 14 20.5042ZM25.9583 17.9083H2.07083V5.48333H25.9583V17.9083Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenIcon);
export default __webpack_public_path__ + "static/media/screen-icon.41a538575031d63f4f530a9800c66de1.svg";
export { ForwardRef as ReactComponent };